// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';

const schema = {
  $id: '/create-safety-anchor-point-request-schema',
  type: 'object',
  required: ['id', 'creatorId', 'siHaDocumentationId', 'safetyHookId', 'screwLength'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    siHaDocumentationId: {
      type: 'integer',
    },
    safetyHookId: {
      type: 'integer',
    },
    name: {
      type: 'string',
      nullable: true,
      maxLength: 255,
    },
    screwLength: {
      type: 'integer',
    },
    remark: {
      type: 'string',
      nullable: true,
    },
    isInstalledOnCounterBatten: {
      type: 'boolean',
    },
    installationRemark: {
      type: 'string',
      nullable: true,
    },
    installationDate: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    isDocumentationCompleted: {
      type: 'boolean',
    },
    previousSafetyAnchorPointId: {
      type: 'integer',
      nullable: true,
    },
    nextSafetyAnchorPointId: {
      type: 'integer',
      nullable: true,
    },
    documentationImage1ExternalId: {
      type: 'string',
      nullable: true,
    },
    documentationImage2ExternalId: {
      type: 'string',
      nullable: true,
    },
    documentationImage3ExternalId: {
      type: 'string',
      nullable: true,
    },
    documentationImage4ExternalId: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
